import logo from "@rosette/assets/src/logo_text_only.svg";
import Link from "next/link";
import { cn } from "@rosette/ts/src/util/cn.js";
import { ByLine } from "@/components/social/banner/ByLine.js";


const LOGO_CLASSES = "block w-full h-[2.5em] [font-size:inherit] no-underline -indent-[999em]";


interface RoyalBannerProps {
    className?: string;
    noLink?: boolean;
    hideByLine?: boolean;
}


export function RoyalBanner({ className, noLink, hideByLine }: RoyalBannerProps) {
    return (
        <div
            className={cn(
                "flex flex-col items-center justify-center w-[6.5em] mx-auto mb-4 text-3xl",
                className ?? null,
            )}>
            {!noLink && (
                <Link
                    href="/"
                    className={LOGO_CLASSES}
                    style={{ background: `url(${logo.src}) no-repeat 50%` }}>

                    RoyalUr.net
                </Link>
            )}

            {noLink && (
                <div
                    className={LOGO_CLASSES}
                    style={{ background: `url(${logo.src}) no-repeat 50%` }}>

                    RoyalUr.net
                </div>
            )}

            {!hideByLine && (
                <ByLine noLink={noLink} />
            )}
        </div>
    );
}
